import { preloadData } from "../components/nascar/utils/hybridDataLoader";

class DataPreloader {
  constructor() {
    this.isPreloaded = false;
    this.preloadPromise = null;
  }

  async preloadStaticData() {
    if (this.isPreloaded) return;
    if (this.preloadPromise) return this.preloadPromise;

    const staticFiles = [
      "calendar.json",
      "next_race_data.json",
      "entry_list.json",
      "track_similarity.json",
      "track_types.json"
    ];

    this.preloadPromise = preloadData(staticFiles)
      .then(() => {
        this.isPreloaded = true;
      })
      .catch((error) => {
        console.error("Error preloading static data:", error);
        this.preloadPromise = null;
      });

    return this.preloadPromise;
  }

  getPreloadStatus() {
    return this.isPreloaded;
  }
}

export const dataPreloader = new DataPreloader();